import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Navigation from './components/Navigation';
import Services from './components/Services';
import KITeam from './components/KITeam';
import BookingSection from './components/BookingSection';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';

export default function HomePage() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  const openBookingModal = () => setIsBookingModalOpen(true);
  const closeBookingModal = () => setIsBookingModalOpen(false);

  return (
    <div className="min-h-screen bg-white">
      <Header onBookingClick={openBookingModal} />
      <Hero onBookingClick={openBookingModal} />
      <Navigation />
      <Services onBookingClick={openBookingModal} />
      <KITeam onBookingClick={openBookingModal} />
      <BookingSection onBookingClick={openBookingModal} />
      <Footer />
      <BookingModal isOpen={isBookingModalOpen} onClose={closeBookingModal} />
    </div>
  );
}
